import { Link } from "react-router-dom";
import { money } from "../api";
import { useCart } from "../context/CartContext";

export default function ProductCard({ product }) {
  const { add } = useCart();

  return (
    <article className="product-card">
      <Link className="product-card-media" to={`/product/${product.slug}`}>
        <img src={product.image} alt={product.name} loading="lazy" />
        {product.featured && <span className="pill">Featured</span>}
      </Link>
      <div className="product-card-body">
        {product.category && <p className="product-cat">{product.category}</p>}
        <h3>
          <Link to={`/product/${product.slug}`}>{product.name}</Link>
        </h3>
        <div className="product-card-meta">
          <span className="price">{money(product.price)}</span>
          <button
            type="button"
            className="btn-icon"
            aria-label={`Add ${product.name} to cart`}
            onClick={() => add(product, 1)}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 5v14M5 12h14" />
            </svg>
          </button>
        </div>
      </div>
    </article>
  );
}
